export const VisibilityType = {
  Open: 'OPEN',
  CloseNewAndDiagnosticians: 'CLOSE_NEW_AND_DIAGNOSTICIANS',
  CloseNew: 'CLOSE_NEW',
  Close: 'CLOSE'
}
